import { IconRender, InheritProps } from '../IconRender';

export function NoneIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="1" y="1" width="48" height="78" rx="7" fill="#343434" stroke={color} strokeWidth="4"/>
          <circle cx="25" cy="40" r="10.5" fill="#343434" stroke="#D9D9D9" strokeWidth="3"/>
          <line x1="33.9521" y1="33.1591" x2="17.9521" y2="46.3019" stroke="#D9D9D9" strokeWidth="3"/>
        </>
      )}
    />
  );
}

